module.exports = __webpack_public_path__ + "static/media/download-line.09a22337.svg";